"use client";
import { useEffect } from "react";
import { pushEventOnce } from "@/lib/analytics/gtm";
import { analyticsEvents } from "@/lib/analytics/events";

interface ViewStickerPackBeaconProps {
  postId: number | string;
  slug: string;
  packTitle: string;
}

export function ViewStickerPackBeacon({ postId, slug, packTitle }: ViewStickerPackBeaconProps) {
  useEffect(() => {
    pushEventOnce(analyticsEvents.view_sticker_pack, `pack:${slug}`, {
      post_id: String(postId),
      post_slug: slug,
      pack_title: packTitle,
    });
  }, [postId, slug, packTitle]);
  return null;
}
